/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description blog
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { default as rootReducer } from './reducers/index'

export default filterActions(rootReducer, Object.values(constants))
